import React from 'react';
import { Avatar, Box, Card, CardContent, Typography, alpha } from '@mui/material';

export interface SysKpiCardProps {
  titulo: string;
  valor: string | number;
  subtitulo?: string;
  icone: React.ReactNode;
  cor: string;
  bgCor: string;
}

const SysKpiCard: React.FC<SysKpiCardProps> = ({ titulo, valor, subtitulo, icone, cor, bgCor }) => (
  <Card
    elevation={0}
    sx={{
      height: '100%',
      borderRadius: 2,
      //border: (theme) => `1px solid ${alpha(theme.palette.divider, 0.8)}`,
      boxShadow: '0px 0px 1px 1px rgba(0, 0, 0, 0.1)',
    }}
  >
    <CardContent sx={{ p: 1.25, '&:last-child': { pb: 1.25 } }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" gap={1}>
        <Box minWidth={0}>
          <Typography variant="caption" color="text.secondary" display="block" lineHeight={1.2}>
            {titulo}
          </Typography>
          <Typography variant="h6" fontWeight={800} color={cor} lineHeight={1.2} noWrap>
            {valor}
          </Typography>
          {subtitulo && (
            <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.65rem' }}>
              {subtitulo}
            </Typography>
          )}
        </Box>
        <Avatar sx={{ bgcolor: bgCor, width: 34, height: 34, '& .MuiSvgIcon-root': { fontSize: 18 } }}>
          {icone}
        </Avatar>
      </Box>
    </CardContent>
  </Card>
);

export default SysKpiCard;
